import type { InvoiceParams } from '@/models/invoices';
import { getActiveMerchantId } from '@/utils/axios.utils';
import {
  InvoicesServiceApiFactory,
  type ModelInvoice,
  type ModelInvoicePdfResponse,
  type ModelInvoiceReport,
} from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const fetchInvoices = async (params?: InvoiceParams): Promise<{ invoices: ModelInvoice[] }> => {
  const client = createLayupClient(false);
  const response = await client.get('v1/invoices', { params });

  return response.data;
};

export const invoiceReportServiceClient = () => {
  const client = createLayupClient();
  return InvoicesServiceApiFactory(undefined, undefined, client);
};

export const getInvoiceById = async (invoiceId: string): Promise<ModelInvoiceReport> => {
  const client = createLayupClient(false);
  const config = getActiveMerchantId();
  const response = await InvoicesServiceApiFactory(undefined, undefined, client).invoicesServiceGetInvoiceReportById(
    { id: invoiceId },
    config,
  );

  return response.data.report!;
};

export const downloadInvoicePdf = async (invoiceId: string): Promise<ModelInvoicePdfResponse> => {
  const client = createLayupClient(false);
  const response = await client.get(`v1/invoices/${invoiceId}/pdf`);

  return response.data;
};
